import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20background%20with%20warm%20gradient%20tones%20of%20cream%20beige%20and%20soft%20coral%2C%20geometric%20patterns%20subtle%2C%20clean%20and%20elegant%20corporate%20aesthetic%2C%20no%20text%2C%20soft%20lighting%2C%20professional%20atmosphere%2C%20artistic%20abstract%20composition&width=1800&height=1200&seq=clsq-hero-bg&orientation=landscape"
          alt="clsq品牌形象"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="w-full max-w-4xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            值得信赖的首选品牌
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            clsq以创新驱动发展，以品质赢得信赖。我们致力于为每一位客户提供卓越的产品与服务，
            助力企业在数字化转型浪潮中乘风破浪，实现可持续增长。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/categories"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-md text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              探索产品服务
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md text-sm md:text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              了解品牌故事
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs text-background-50/60">向下滚动</span>
        <i className="ri-arrow-down-s-line text-background-50/60"></i>
      </div>
    </section>
  );
}